import React from 'react'
import Layout from '../../layouts/Layout'
import { Link } from 'react-router-dom'

function PageNotFound() {
  return (
    <Layout header={1} footer={1}>
        <div style={{display: "flex", minHeight: "100vh", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: 33}}>
            <h2>404 No Page Found</h2>
            <Link to="/">
            <button className="btn">
          Back to Home
        </button>
        </Link>
        </div>
        
    </Layout>
  )
}

export default PageNotFound